import React from "react";
import { Button } from "components/ui";
import { useTranslation } from "lib/i18n/use-translation";
import { ReactComponent as IconChevron } from "Assets/icon/icon-chevron.svg";
import { trackEvent } from "utility/mixpanel";
import { FilterToggleProps } from "./types";
import styles from "./styles.module.scss";

export const FilterToggle: React.FC<FilterToggleProps> = ({
  showFilters,
  activeFilters,
  handleFilterToggle,
  activeTab,
}) => {
  const { t } = useTranslation(["discover"]);
  const activeFilterCount = Object.entries(activeFilters).reduce(
    (count, [key, values]) => {
      const filteredValues = values.filter((value) => value !== "all");
      return count + filteredValues.length;
    },
    0
  );

  const onFilterToggle = () => {
    trackEvent(`Filter Drawer ${!showFilters ? "Opened" : "Closed"}`, {
      "Content Type": activeTab,
    });
    handleFilterToggle();
  };

  return (
    <div className={styles.filterToggle}>
      <Button
        variant="enclosed-primary"
        icon={
          showFilters ? (
            <IconChevron
              width={24}
              height={24}
              className={styles.chevronIcon}
            />
          ) : (
            <IconChevron width={24} height={24} />
          )
        }
        iconPosition="end"
        onClick={onFilterToggle}
        className={styles.filterToggleButton}
      >
        <div className={styles.filterButtonContent}>
          <span>{t("discover:filters.toggle")}</span>
          {activeFilterCount > 0 && (
            <span className={styles.activeFilterCount}>
              {`(${activeFilterCount})`}
            </span>
          )}
        </div>
      </Button>
    </div>
  );
};
